import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "../../lib/api";
import { ChatList } from "./inbox/ChatList";
import { ChatView } from "./inbox/ChatView";
import { ProfilePanel } from "./inbox/ProfilePanel";
import { InboxSetupBanner } from "./inbox/SetupBanner";

export default function WaInbox() {
  const [params, setParams] = useSearchParams();
  const active = params.get("chat") || "";
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [filter, setFilter] = useState("all");
  const [conv, setConv] = useState(null);
  const [info, setInfo] = useState(false);
  const [drafts, setDrafts] = useState({});

  const loadList = useCallback(() => api.get("/wa-inbox/conversations", { params: { q, filter } }).then(({ data }) => setItems(data)).catch(() => {}), [q, filter]);
  useEffect(() => { loadList(); const t = setInterval(loadList, 5000); return () => clearInterval(t); }, [loadList]);

  const open = (phone) => { setParams(phone ? { chat: phone } : {}); };
  const startChat = async (num) => {
    try { const { data } = await api.post("/wa-inbox/conversations/start", { phone: num }); loadList(); open(data.phone); return true; }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); return false; }
  };
  const draft = drafts[active] || "";
  const setDraft = (v) => setDrafts((d) => ({ ...d, [active]: v }));

  return (
    <div className="-m-4 sm:-m-6 lg:-m-8 h-[calc(100vh-4rem)] flex flex-col bg-white overflow-hidden" data-testid="wa-inbox-page">
      <InboxSetupBanner />
      <div className="flex-1 min-h-0 flex">
      <div className={`w-full md:w-[360px] lg:w-[400px] flex-shrink-0 border-r border-slate-200 ${active ? "hidden md:block" : "block"}`}>
        <ChatList items={items} active={active} onOpen={open} q={q} setQ={setQ} filter={filter} setFilter={setFilter} onNew={startChat} />
      </div>
      <div className={`flex-1 min-w-0 ${active ? "flex" : "hidden md:flex"}`}>
        {active ? (
          <ChatView phone={active} conv={conv} setConv={setConv} onBack={() => open("")} onInfo={() => setInfo((i) => !i)}
            onConvChange={(c) => { setConv(c); loadList(); }} draft={draft} setDraft={setDraft} refreshList={loadList} />
        ) : (
          <div className="flex-1 flex flex-col items-center justify-center bg-[#f0f2f5] border-b-[6px] border-[#25d366] text-center px-8" data-testid="inbox-empty-state">
            <div className="w-20 h-20 rounded-full bg-[#25d366]/10 flex items-center justify-center"><MessageCircle className="w-10 h-10 text-[#25d366]" /></div>
            <h2 className="mt-5 text-2xl font-light text-[#41525d]">GDIOT PAY WhatsApp</h2>
            <p className="mt-2 text-sm text-[#667781] max-w-md">Read every parent reply and answer from here. Free messages can be sent within 24 hours of the parent's last message; after that, send an approved template.</p>
          </div>
        )}
      </div>
      {active && info && conv?.phone === active && (
        <div className="fixed inset-0 z-40 lg:static lg:z-auto lg:w-[340px] flex-shrink-0">
          <ProfilePanel conv={conv} onClose={() => setInfo(false)} onConvChange={(c) => { setConv(c); loadList(); }}
            onInsertLink={(link) => { setDraft(`${draft ? `${draft} ` : ""}${link}`); setInfo(false); toast.success("Payment link added to your message"); }} />
        </div>
      )}
      </div>
    </div>
  );
}
